import {
  Button,
  Grid,
  InputAdornment,
  Typography,
  styled,
} from "@mui/material";

import PriceInput from "components/PriceInput";
import { useFormContext } from "react-hook-form";

function WithdrawAmount({ selectedCoin, withdrawAmountMax }) {
  const { watch, setValue } = useFormContext();
  const amount = watch("amount");

  const max = withdrawAmountMax?.withdrawAmountMax;
  const min = selectedCoin?.minimumWithdrawAmount;

  return (
    <Grid item xs={12}>
      <Typography variant="h6" color="text.main">
        Withdraw Amount
      </Typography>

      <PriceInput
        showPrefix={false}
        coinName={selectedCoin?.coinName}
        placeholder={selectedCoin?.name}
        max={max}
        min={min}
        maxDecimal={selectedCoin?.decimalPlacesWithdraw}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <Typography mr={1} variant="h5" color="text.secondary">
                {selectedCoin?.coinName}
              </Typography>

              <ButtonStyle
                variant="text"
                color="secondary"
                onClick={() => setValue("amount", max)}
              >
                Max
              </ButtonStyle>
            </InputAdornment>
          ),
        }}
        value={amount}
        onChange={(e) => setValue("amount", e)}
      />
    </Grid>
  );
}

export const ButtonStyle = styled(Button)(({ theme }) => ({
  padding: theme.spacing(0),
  minWidth: "40px",
  minHeight: "40px !important",
}));

export default WithdrawAmount;
